import { Star } from "@mui/icons-material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { EvaluationStarsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationStarModels";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: EvaluationStarsSubtypeDataModel;
}

export default function EvaluationStarsSubtypeDetails(props: Props) {
    return <>
        {[1, 2, 3, 4, 5].map(i =>
            <Star color={props.subtypeData.numberOfStars >= i ? "primary" : "secondary"} />)}
    </>
}